import { render, staticRenderFns } from "./uploadDialog.vue?vue&type=template&id=5d53fa3e&scoped=true"
import script from "./uploadDialog.vue?vue&type=script&lang=js"
export * from "./uploadDialog.vue?vue&type=script&lang=js"
import style0 from "./uploadDialog.vue?vue&type=style&index=0&id=5d53fa3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53fa3e",
  null
  
)

export default component.exports